import { selectCurrentEntities } from 'ducks/entities/selectors'
import { createSelector } from 'reselect'
import { featureArrayToFeatureLookup } from '../util'

export const selectAvailableFeatures = createSelector(
  state => selectCurrentEntities(state, 'feature'),
  features => featureArrayToFeatureLookup(features)
)
